var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"option-selector"},[_c('v-autocomplete',{attrs:{"value":_vm.value,"items":_vm.items,"placeholder":_vm.placeholder,"label":_vm.label,"item-text":"name","item-value":"id","loading":_vm.loading,"outlined":""},on:{"change":function($event){return _vm.$emit('input', $event)}}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }